import Trace from './Trace';

export default Trace;
